import { Inject, Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError, mergeMap, take } from 'rxjs/operators';

import { IConfigurationService } from './configuration-service.interface';

@Injectable()
export class ConfigurationResolverService {
  constructor(@Inject('IConfigurationService') private configurationService: IConfigurationService) {}

  resolve(): Observable<any> {
    return this.configurationService.getDataFromServer().pipe(
      take(1),
      mergeMap((data) => {
        if (data) {
          return of(data.data);
        } else {
          return of(null);
        }
      }),
      catchError(() => {
        return of(null);
      })
    );
  }
}
